var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from 'redux-saga/effects';
import { GET_STORE_DATA_REQUEST, getStoreDataFailure, getStoreDataSuccess } from '../../actions';
import API from '../../../utils/API';
const onGetStoreData = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            API.get(`onbd/channel/${action.payload.channelId}`)
                .then(data => {
                resolve(data);
            })
                .catch(error => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* getStoreDataWorker(action) {
    try {
        const data = yield call(onGetStoreData, action);
        yield put(getStoreDataSuccess(data));
    }
    catch (error) {
        yield put(getStoreDataFailure(error));
    }
}
export function* watchGetStoreData() {
    yield takeLatest(GET_STORE_DATA_REQUEST, getStoreDataWorker);
}
